<template>
  <div data-testid="cycle-breadcrumb" class="fc-cycle-breadcrumb">
    <button
      data-testid="cycle-breadcrumb__cycles-chip"
      type="button"
      class="fc-cycle-breadcrumb__chip"
      :class="{ 'fc-cycle-breadcrumb__chip--active': isCyclesActive }"
      @click="goHome"
    >
      <img
        data-testid="cycle-breadcrumb__home-icon"
        src="/img/navicon/fbc-nav/CyclesHome.svg"
        alt=""
        class="fc-cycle-breadcrumb__chip-icon"
      />
      <span>Cycles</span>
    </button>

    <template v-if="cycleLabel">
      <v-icon
        data-testid="cycle-breadcrumb__chevron"
        class="fc-cycle-breadcrumb__chevron"
        color="white"
        size="16"
      >mdi-chevron-right</v-icon>

      <v-menu
        v-model="cycleMenu"
        data-testid="cycle-breadcrumb__cycle-menu"
        offset-y
        :nudge-bottom="6"
        :close-on-content-click="false"
        content-class="fc-cycle-switcher__menu"
        transition="fade-transition"
        @input="onCycleMenuToggle"
      >
        <template #activator="{ on, attrs }">
          <button
            type="button"
            data-testid="cycle-breadcrumb__cycle-label"
            class="fc-cycle-breadcrumb__cycle"
            :class="{ 'fc-cycle-breadcrumb__cycle--open': cycleMenu }"
            v-bind="attrs"
            v-on="on"
            :title="cycleLabel"
            aria-haspopup="true"
            :aria-expanded="String(cycleMenu)"
          >
            <span class="fc-cycle-breadcrumb__cycle-text">{{ cycleLabel }}</span>
          </button>
        </template>

        <v-card flat class="fc-cycle-switcher__card">
          <cycle-switcher-dropdown
            :cycles="cycles"
            :active-cycle-id="activeCycleId"
            :loading="cyclesLoading"
            @cycle-selected="onCycleSelected"
          />
        </v-card>
      </v-menu>
    </template>
  </div>
</template>

<script>
import { FC_ROUTES } from '@/modules/financialclose/utils/constants';
import { isFbcCyclesLanding, isFbcCycleRoute, isFbcSettingsRoute } from './financialCloseTopNavUtils';
import CycleSwitcherDropdown from './CycleSwitcherDropdown.vue';

export default {
  name: 'CycleBreadcrumb',
  components: { CycleSwitcherDropdown },
  props: {
    cycleLabel: { type: String, default: '' },
    selectedClientId: { type: String, default: '' },
    cycles: { type: Array, default: () => [] },
    activeCycleId: { type: String, default: null },
    cyclesLoading: { type: Boolean, default: false },
  },
  emits: ['cycle-selected', 'open-cycle-menu'],
  data() {
    return {
      cycleMenu: false,
    };
  },
  computed: {
    /** Highlight Cycles on landing, homeview, and any in-cycle route (not setup). */
    isCyclesActive() {
      const path = this.$route?.path || '';
      if (isFbcSettingsRoute(path)) return false;
      return (
        isFbcCyclesLanding(path)
        || path === FC_ROUTES.HOMEVIEW
        || isFbcCycleRoute(path)
      );
    },
  },
  methods: {
    goHome() {
      this.cycleMenu = false;
      // Ask Noa is a floating overlay that keeps the current route; dismiss it even when
      // already on Cycles home so the landing page is revealed.
      this.$root.closeFloatingComponents?.();
      this.$nova.gotoLink({
        path: FC_ROUTES.HOME,
        query: this.selectedClientId ? { cid: this.selectedClientId } : undefined
      });
    },
    onCycleMenuToggle(isOpen) {
      if (isOpen) {
        this.$emit('open-cycle-menu');
      }
    },
    onCycleSelected(cycle) {
      this.cycleMenu = false;
      this.$emit('cycle-selected', cycle);
    },
  },
  beforeDestroy() {
    this.cycleMenu = false;
  },
};
</script>
